"use client"
import PropTypes from "prop-types"

const Words = ({ words = [], currentVal = "", description = "", onChange = () => {} }) => {
  return (
    <div className="numbers">
      <span className="description">{description}</span>
      {words.map((word, index) => (
        <span
          key={index}
          className={"word " + (index === currentVal ? "selected " : "") + (word.disabled ? "disabled hidden" : "")}
          onClick={() => (!word.disabled ? onChange(index) : {})}
          title={word.title || ""}
        >
          {word.name}
        </span>
      ))}
    </div>
  )
}

Words.propTypes = {
  words: PropTypes.arrayOf(PropTypes.any),
  currentVal: PropTypes.any,
  description: PropTypes.string,
  onChange: PropTypes.func,
}

export default Words
